export function authHeader() {
  const headers: {Authorization?: string} = {}
  const media = localStorage.getItem('media')

  if (media) {
    const { token } = JSON.parse(media)

    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
  }
  return headers
}